import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import {
  Context,
  PreloadActionModalSchema,
  PreloadTransitionOptions,
  Transitions
} from "../../types"
import { saveCancelModalState } from "./saveCancelModalState"

export const preloadModalState = <T = any>(
  returnTarget: string,
  serviceCall: string,
  options: PreloadTransitionOptions<T>
): StateNodeConfig<
  Context,
  PreloadActionModalSchema,
  Transitions,
  BaseActionObject
> => {
  const { loadingState, preload } = options

  return {
    initial: "loading",
    states: {
      loading: {
        entry: assign<Context>(ctx => ({
          loading: loadingState
            ? { ...ctx.loading, [loadingState]: true }
            : ctx.loading
        })),
        exit: assign<Context>(ctx => ({
          loading: loadingState
            ? { ...ctx.loading, [loadingState]: false }
            : ctx.loading
        })),
        invoke: {
          id: "loading",
          src: preload.serviceCall,
          onDone: {
            target: "idle",
            actions: preload.successActions
          },
          onError: {
            target: "idle",
            actions: preload.errorActions
          }
        }
      },
      ...saveCancelModalState(returnTarget, serviceCall, options).states
    }
  }
}
